<mat-checkbox
    [indeterminate]="value === null"
    [matTooltip]="!!toolTipsMapping && !!toolTipsMapping.length && getToolTip()"
    [checked]="value"
    (change)="onChange()"
    [disabled]="isDisabled"
>
</mat-checkbox>
